import Tiles, { TilesProps } from "~/components/UI/Tiles";
import { Box } from "~/components/UI";
import EvPortCard from "./EvPortCard";

/**
 * @memberof EvPorts
 * @component
 * @desc Render tiles of EvPorts.
 * @property {Api.EvPortDto[]} list - EvPorts data
 */

const EvPortTiles = (props: Omit<TilesProps<Api.EvPortDto> & {}, "renderTaile">) => (
  <Box pb={2}>
    <Tiles
      {...props}
      customHeight={true}
      renderTaile={(evPort, key) => <EvPortCard key={key} evPort={evPort} />}
    />
  </Box>
);

export default EvPortTiles;
